import './PinCode.scss';

export interface PinCodeProps {
  drawer: string;
  id: number;
  inline: boolean;
  inputValue: string;
  inputError: string;
  locationName: string;
  note: string;
  onInputChange: (value: string) => void;
  pinCode: string | undefined;
}

export default function PinCode({
  drawer,
  id,
  inline,
  inputValue,
  inputError,
  locationName,
  note,
  onInputChange,
  pinCode,
}: PinCodeProps) {
  return (
    <div key={id} className={`pin-code${inline ? ' pin-code--inline' : ''}`}>
      <div className="pin-code__details">
        <h2 className="pin-code__name">
          <span className="pin-code__name--highlighted">{locationName}</span> - {drawer} Drawer
        </h2>
        <div role="note" className="pin-code__note">
          {note}
        </div>
        <div className="pin-code__wrapper">
          <div role="figure" className="pin-code__code">
            <span className="pin-number">{pinCode}</span>
            <span>CODE</span>
          </div>
          <div className={`pin-code__givento${!inputValue || !!inputError ? ' pin-code__givento--error' : ''}`}>
            <label className="pin-code__label" htmlFor="given-to">
              Given to{(!inputValue || !!inputError) && '*'}
              {!!inputError && <small className="pin-code__label-error">{inputError}</small>}
            </label>
            <input
              id="given-to"
              type="text"
              className="pin-code__input"
              value={inputValue || ''}
              onChange={(e) => onInputChange(e.target.value)}
              placeholder="Recipient"
            ></input>
          </div>
        </div>
      </div>
    </div>
  );
}
